import * as React from 'react';
import Box from '@mui/material/Box';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { FormGroup ,Typography } from '@mui/material';
import { INewAccountData } from '../SignupPage';
import protectAxios from '../../../api/axios';

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  minHeight: '300px',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

interface SignupStep4Props {
  onPreviousClick: VoidFunction;
  formData : INewAccountData;
}

export const SignupStep4 : React.FC<SignupStep4Props> = (props) => {
  
  const [ accountCreated, setAccountCreated ] = React.useState(false);
  
  const createAccount = () =>
  {
      protectAxios.post("companycommands/create", props.formData).then(() => {
        setAccountCreated(true);
      })
  };
 
  return (
      <Card variant="outlined">
        <Box sx={{ display: { xs: 'flex' } }}>
          <img src="/logo.png" alt="Logo" style={{ height: 40, paddingBottom:0 }} />  
        </Box>

        <Typography
            component="h1"
            variant="h4"
            sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
            >
          Create Account
        </Typography>

        <Typography sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}>
          Please click 'Create' to create your new account.  Once created, you will have the option to login.
        </Typography>

        <FormGroup row sx={{justifyContent:'flex-end'}}>
          {accountCreated ? <></> :  
            <Button
                variant="outlined"
                color="primary"
                sx={{ mt: 2, mr: 2 }}
                onClick={props.onPreviousClick}
            >
                Previous
            </Button>
          }  
          
          {accountCreated ? <></> :             
              <Button
                variant="outlined"
                color="primary"
                onClick={() => createAccount()}
                sx={{ mt: 2 }}
              >
                Create
              </Button>   
          }
            
          {accountCreated ?             
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={() => window.location.href = "/login"}
              >
                Go to Login
              </Button> : 
              <></>
          }
        </FormGroup>
      </Card>
 
  )
}